var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15223 17.2353C7.91276 16.6709 8.74125 16.2252 9.63771 15.8983C10.5342 15.5714 11.4883 15.4079 12.5 15.4079C13.5117 15.4079 14.4658 15.5714 15.3623 15.8983C16.2587 16.2252 17.0872 16.6709 17.8478 17.2353C18.4041 16.6238 18.8449 15.9161 19.1701 15.112C19.4953 14.3078 19.6579 13.4372 19.6579 12.5C19.6579 10.5167 18.9608 8.82784 17.5665 7.43354C16.1722 6.03924 14.4833 5.34209 12.5 5.34209C10.5167 5.34209 8.82784 6.03924 7.43354 7.43354C6.03924 8.82784 5.34209 10.5167 5.34209 12.5C5.34209 13.4372 5.50469 14.3078 5.8299 15.112C6.15511 15.9161 6.59588 16.6238 7.15223 17.2353ZM12.5 13.171C11.6833 13.171 10.9944 12.8906 10.4335 12.3296C9.87258 11.7687 9.59212 11.0799 9.59212 10.2632C9.59212 9.44642 9.87258 8.75759 10.4335 8.19666C10.9944 7.63574 11.6833 7.35527 12.5 7.35527C13.3167 7.35527 14.0056 7.63574 14.5665 8.19666C15.1274 8.75759 15.4079 9.44642 15.4079 10.2632C15.4079 11.0799 15.1274 11.7687 14.5665 12.3296C14.0056 12.8906 13.3167 13.171 12.5 13.171ZM12.5 21C11.3196 21 10.2124 20.778 9.1783 20.3341C8.14419 19.8902 7.24458 19.2856 6.47946 18.5205C5.71435 17.7554 5.10983 16.8558 4.66591 15.8217C4.22197 14.7876 4 13.6804 4 12.5C4 11.3196 4.22197 10.2124 4.66591 9.1783C5.10983 8.14419 5.71435 7.24458 6.47946 6.47946C7.24458 5.71435 8.14419 5.10983 9.1783 4.66591C10.2124 4.22197 11.3196 4 12.5 4C13.6804 4 14.7876 4.22197 15.8217 4.66591C16.8558 5.10983 17.7554 5.71435 18.5205 6.47946C19.2856 7.24458 19.8902 8.14419 20.3341 9.1783C20.778 10.2124 21 11.3196 21 12.5C21 13.6804 20.778 14.7876 20.3341 15.8217C19.8902 16.8558 19.2856 17.7554 18.5205 18.5205C17.7554 19.2856 16.8558 19.8902 15.8217 20.3341C14.7876 20.778 13.6804 21 12.5 21Z",
    fill: "#1EB65B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_238_2940",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.899902,
    width: 24,
    height: 24,
    fill: "#1EB65B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_238_2940)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGreen);
export default __webpack_public_path__ + "static/media/profile_green.f55097e45c784cba7e9b00a16cc85eaf.svg";
export { ForwardRef as ReactComponent };